import script from "./concept.vue?vue&type=script&setup=true&lang=js"
export * from "./concept.vue?vue&type=script&setup=true&lang=js"

import "./concept.vue?vue&type=style&index=0&id=feda0894&lang=less"
import "./concept.vue?vue&type=style&index=1&id=feda0894&lang=less&scoped=true"
script.__scopeId = "data-v-feda0894"

export default script